import type { User } from '../../types';
import ConfirmModal from '../ConfirmModal/ConfirmModal';

type Props = {
  member: User;
  actorIsPilot: boolean | undefined;
  submitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function TransferOwnershipModal({
  member,
  actorIsPilot,
  submitting,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <ConfirmModal
      title="Передать владение клубом?"
      message={
        actorIsPilot === false
          ? `«${member.name}» станет владельцем клуба. Вы останетесь участником с ролью «Модератор» (права админа без доли). Это действие необратимо без согласия нового владельца.`
          : `«${member.name}» станет владельцем клуба. Вы останетесь участником с ролью «Админ». Это действие необратимо без согласия нового владельца.`
      }
      confirmLabel="Передать владение"
      cancelLabel="Отмена"
      danger
      submitting={submitting}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
